import { Injectable } from "@angular/core";
import { BaseManager } from "./base.manager";
import { LocalStorageRepositoryInterface } from "../../datastore/local/localstorage.interface";
import { LogRepositoryInterface } from "../../datastore/repositories/log/log.interface";
import { Observable } from "rxjs";
import { LogList } from "../../datastore/entities/loglist.model";

@Injectable()
export class LogManager extends BaseManager {
    constructor(
        protected localStorageRepository: LocalStorageRepositoryInterface,
        private logRepository: LogRepositoryInterface) {
        super(localStorageRepository);
    }

    /* eslint-disable camelcase, @typescript-eslint/camelcase */
    public addEvent(targetUUID: string, tag: number): Observable<{}> {
        return this.logRepository.addEvent({
            actor_uuid: this.localStorageRepository.getLoggedUserId(),
            target_uuid: targetUUID,
            tag
        });
    }

    public getLogs(size: number, page: number): Observable<LogList> {
        return this.logRepository.getLogs(size, page);
    }
}